<script>
  import {onMount} from "svelte";

  import SubHeader from "../components/SubHeader.svelte";
  import Agreement from "./GuideAgreement.svelte";
  import Policy from "./GuidePolicy.svelte";
  import Email from "./GuideEmail.svelte";
  import "../styles/guide.css";

  let select_guide;
  let subHeader = {
    bg_pc: '/images/sub_inquiry.png',
    bg_mo: '/images/sub_inquiry_m.png',
    title: '',
    dsc: ''
  }

  onMount(() => {
    select_guide = location.hash.slice(8) || 'agreement';

    if (select_guide === 'agreement') {
      subHeader = {
        bg_pc: subHeader.bg_pc,
        bg_mo: subHeader.bg_mo,
        title: '이용약관',
        dsc: '커피멘토 홈페이지 서비스 이용과 관련하여 필요한 사항을 규정합니다.',
      }
    } else if (select_guide === 'policy') {
      subHeader = {
        bg_pc: subHeader.bg_pc,
        bg_mo: subHeader.bg_mo,
        title: '개인정보처리방침',
        dsc: '커피멘토는 개인정보보호법 등 법령상의 개인정보보호규정을 준수합니다.',
      }
    } else if (select_guide === 'email-collection-refuse') {
      subHeader = {
        bg_pc: subHeader.bg_pc,
        bg_mo: subHeader.bg_mo,
        title: '이메일주소 무단수집거부',
        dsc: '커피멘토 웹사이트에 게시된 이메일 주소가 무단으로 수집되는 것을 거부합니다.',
      }
    }
  });
</script>

<SubHeader {...subHeader} />

<section class="guide">
  {#if select_guide === 'agreement'}
  <Agreement />
  {:else if select_guide === 'policy'}
  <Policy />
  {:else if select_guide === 'email-collection-refuse'}
  <Email />
  {/if}
</section>
